import Modal from "Components/Modal";
import React, { useEffect } from "react";

interface Props {
  time?: number;
  onClose?: () => void;
  isOpen?: boolean;
  children: React.ReactNode;
}

const Popup: React.FC<Props> = ({
  time = 13000,
  onClose,
  isOpen,
  children,
}) => {
  useEffect(() => {
    if (!!time) {
      const interval = setTimeout(() => {
        onClose();
      }, time);

      return () => {
        clearTimeout(interval);
      };
    }
  }, [onClose, time]);

  if (!isOpen) {
    return <></>;
  }

  return (
    <Modal defaultWidth="none" isOpen={isOpen} handleClose={() => onClose()}>
      {children}
    </Modal>
  );
};

export default Popup;
